import Contactform from "./_components/contact-form";




export default function Contact() {
  return (
    <>

      <div className="flex flex-col min-h-screen max-w-[1200px] lg:mx-auto px-[1.25em]">

        <Contactform/>
      
      
      
      </div>


    </>
  );
}
